module.exports = __webpack_public_path__ + "img/专属定制.9496d8d3.png";